import { createSelector } from '@ngrx/store';

import { AppState } from '../app.state';
import { MessagesState } from './messages.reducer';

export const selectMessages = createSelector(
  (state: AppState) => state.messages,
  (messages: MessagesState) => messages
);

export const selectMessagesLoading = createSelector(
  selectMessages,
  (state: MessagesState) => state.messages.loading
);

export const selectMessagesPageOf = createSelector(
  selectMessages,
  (state: MessagesState) => state.messages.pageOfMessages
);
